"use strict";

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var utils_2 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../../molecules/IconLink");

var FilMetaBar =
/** @class */
function (_super) {
  __extends(FilMetaBar, _super);

  function FilMetaBar(props) {
    var _this = _super.call(this, props) || this;

    _this.closeInfoBox = function () {
      window.requestAnimationFrame(function () {
        return _this.setState({
          isInfoBoxOpen: false
        });
      });
      utils_2.WidgetEvents.removeBodyClose(_this.closeInfoBox);
    };

    _this.state = {
      isInfoBoxOpen: false
    };
    return _this;
  }

  FilMetaBar.prototype.componentWillUnmount = function () {
    utils_2.WidgetEvents.removeBodyClose(this.closeInfoBox);
  };

  FilMetaBar.prototype.render = function () {
    var _this = this;

    var applicationData = this.props.applicationData;
    var adviserName = (applicationData.adviserFirstName || "") + " " + (applicationData.adviserLastName || "");
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "metabar", CSSPrefix_1.lsgPre + "filmetabar", CSSPrefix_1.lsgPre + "theme__dark"])
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "metabar-inner"
    }, React.createElement("div", {
      className: "mod mod-NavMetaFil"
    }, React.createElement(IconLink_1.IconLink, {
      href: "/filiale/berater/personsearch",
      className: "searchLink-fil",
      iconName: "i_211"
    }, "Personensuche"), applicationData.isPersonSelected && React.createElement(IconLink_1.IconLink, {
      className: "info-box-link info-fil-link",
      onClick: function onClick(e) {
        e.preventDefault();

        _this.setState(function (prevState) {
          return {
            isInfoBoxOpen: !prevState.isInfoBoxOpen
          };
        });
      },
      iconName: applicationData.juristicalPerson && "i_967" || applicationData.underage && "i_1006" || "i_613",
      look: IconLink_1.IconLink.Looks.RIGHT
    }, React.createElement("span", {
      className: "customerName-fil"
    }, applicationData.firstName, " ", applicationData.lastName, applicationData.isParticipantSelected && "TN " + applicationData.userId))), this.state.isInfoBoxOpen && React.createElement("div", {
      className: "info-box-msg info-fil-msg tt-p-top tt-p-center open",
      id: "info-fil-context",
      ref: function ref(r) {
        utils_2.WidgetEvents.removeBodyClose(_this.closeInfoBox);
        if (r) utils_2.WidgetEvents.addBodyClose(r, _this.closeInfoBox);
      }
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("ul", null, React.createElement("li", null, React.createElement("strong", null, React.createElement("span", null, "KdNr:"), " ", applicationData.mainCustomerNumber), applicationData.juristicalPerson && " - juristische Person" || applicationData.underage && " - minderj&#228;hrig" || " - natürliche Person"), React.createElement("li", null, React.createElement("span", null, "Geburtsdatum:"), " ", applicationData.dateOfBirth)), React.createElement("ul", {
      className: "contactDetails"
    }, React.createElement("li", null, React.createElement(Icon_1.Icon, {
      name: "i_613"
    }), React.createElement("span", null, "Berater:"), "\xA0", adviserName.trim() === "" ? applicationData.adviserNumber : adviserName)), React.createElement("ul", {
      className: "ll"
    }, React.createElement("li", null, React.createElement(IconLink_1.IconLink, {
      href: "/filiale/berater/evalink",
      target: "_blank",
      iconName: "i_627"
    }, "Wechsel zu Eva")), applicationData.activateOnlineBanking && React.createElement("li", null, React.createElement(IconLink_1.IconLink, {
      href: "/banking/fasttrackparticipantcreation",
      iconName: "i_627"
    }, "Online Banking aktivieren")), !applicationData.isConsultantView && React.createElement("li", null, React.createElement(IconLink_1.IconLink, {
      href: "/filiale/berater/consultantview",
      iconName: "i_627"
    }, "Beratersicht einschalten")))))));
  };

  return FilMetaBar;
}(React.Component);

exports.FilMetaBar = FilMetaBar;